import { useEffect, useRef, useState } from 'react';
import { useAuth } from 'src/contexts/auth';
import { ModelOfOrderService } from 'src/database';
import api from '../../services/api';

export const useFinishOrderServiceListController = () => {
	const { userAgencyId } = useAuth();
	const [loading, setLoading] = useState(true);
	const [finishOrderServiceData, setFinishOrderServiceData] = useState<ModelOfOrderService[]>([]);

	const toast: any = useRef();

	const getOrderServices = () => {
		api.post('/list-services-order', { ORGAO: userAgencyId, STATUS: 1 })
			.then((response) => {
				setFinishOrderServiceData(
					response.data.filter((item: any) => {
						return item.ORGAO === userAgencyId;
					})
				);
				setLoading(false);
			})
			.catch((err) => {
				console.log(err);
				setLoading(false);
			});
	};

	const handleClickOrderService = (OrderService: ModelOfOrderService) => {
		const produtos = OrderService.PRODUTOS.map((product: any) => {
			let conta = product.VALOR_PRODUTO * product.QUANTIDADE_PRODUTO;
			return { ...product, VALOR_PRODUTOBASE: product.VALOR_PRODUTO, VALOR_PRODUTO: conta };
		});

		const servicos = OrderService.SERVICOS.map((service: any) => {
			let conta = service.VALOR_SERVICO * service.QUANTIDADE_SERVICO;
			return { ...service, VALOR_SERVICOBASE: service.VALOR_SERVICO, VALOR_SERVICO: conta };
		});

		return { ...OrderService, PRODUTOS: produtos, SERVICOS: servicos };
	};

	useEffect(() => {
		getOrderServices();
	}, []);

	return {
		getFinishOrderServiceListController: {
			finishOrderServiceData,
			loading,
			toast,
		},
		handleFinishOrderServiceListController: {
			handleClickOrderService,
		},
	};
};
